export default __webpack_public_path__ + "static/media/MQ.b1bb6b2a.svg";